import alea from 'alea';

interface Alea extends ReturnType<typeof alea> {
  new(...seed: string[]): Alea;
}

export interface IRNG<T, State = T[]> {
  next(): T;
  serialize(): State;
  clone(): IRNG<T, State>;
}

export type RNGState = [number, number, number, number];

export default class RNG implements IRNG<number, RNGState> {
  private readonly rng: Alea;

  constructor(...seed: string[]) {
    this.rng = new (alea as unknown as Alea)(...seed);
  }

  next(): number {
    return this.rng.next();
  }

  serialize(): RNGState {
    return this.rng.exportState();
  }

  static deserialize(state: RNGState) {
    const rng = new RNG();
    rng.rng.importState(state);
    return rng;
  }

  clone() {
    return RNG.deserialize(this.serialize());
  }
}
